export default __webpack_public_path__ + "static/media/icon-human.a9adeb2a.png";